<template>
    <div class="unlock-quota-free-container">
        <div class="unlock-quota-free" v-if="Type == 1">
            <div class="unlock-quota-free-Title">
                <TipsAndPrivewDilog :id="'SaleLead_Free_Tips'" :Title="$t('lbl_EMPBE_SalesLeadFreeQuota_P')">
                    <template v-slot:Text>
                        {{ $t('lbl_EMPBE_SalesLeadFreeQuota', { remainingCredit: YearRemainingQuota }) }}
                    </template>
                </TipsAndPrivewDilog>
            </div>
            <a
                :href="UpgradeUrl"
                target="_blank"
                :t_label="tLabel('UpgradePlan')"
            >{{ $t('lbl_EMPBE_SalesLeadFreeQuota_Defaultbutton') }}</a>
        </div>
        <div v-if="Type == 2"
            :class="`unlock-quota-free-Page ${IsLock ? 'unlock-quota-free-Page-lock' : 'unlock-quota-free-Page-Unlock'}`">
            <div class="unlock-quota-free-Page-Nav">
                <img :src="IsLock ? lockImg : unlockImg" alt="unlock Quota Image" />
                <div class="unlock-quota-free-Page-Nav-Body">
                    <div>
                        <div class="Title-lock" v-if="IsLock">
                            {{ isBookmarkUnlock ? bookmarkQuotaText : $t('lbl_EMPBE_SalesLeadFreeQuota_Tips') }}
                        </div>
                        <div class="Title-Unlock" v-if="!IsLock">

                            {{ isBookmarkUnlock ? bookmarkQuotaText : $t('lbl_EMPBE_SalesLeadFreeQuotaUnlock_Tips') }}
                        </div>
                    </div>
                    <div>
                        <a v-if="IsLock && mobile" class="lockButton" @click="OpenDialog" :t_label="tLabel('OpenUnlockDialog')"><img
                                :src="`${cdnURL}SalesLeadLock.svg`" alt="unlock Quota Image" />
                          {{ isBookmarkUnlock ? bookmarkSendInvitationText : $t('lbl_EMPBE_SalesLeadFreeQuota_Unlock', {remainingCredit: YearRemainingQuota, maxCredit: EveryYearQuota})}}
                        </a>
                        <a v-if="!IsLock && mobile" class="UnlockButton" :href="UpgradeUrl" target="_blank" :t_label="tLabel('UpgradePlan')">{{
                            $t('lbl_EMPBE_SalesLeadFreeQuota_Defaultbutton') }}</a>
                    </div>
                </div>
            </div>
            <a v-if="IsLock && !mobile" class="lockButton" @click="OpenDialog" :t_label="tLabel('OpenUnlockDialog')"><img :src="`${cdnURL}SalesLeadLock.svg`"
                    alt="unlock Quota Image" />
                {{isBookmarkUnlock ? bookmarkSendInvitationText : $t('lbl_EMPBE_SalesLeadFreeQuota_Unlock', {remainingCredit: YearRemainingQuota, maxCredit: EveryYearQuota})}}</a>
            <a v-if="!IsLock && !mobile" class="UnlockButton" :href="UpgradeUrl" target="_blank" :t_label="tLabel('UpgradePlan')">{{ $t('lbl_EMPBE_SalesLeadFreeQuota_Defaultbutton') }}</a>
        </div>
        <ConfettiExplosion ref="confetti" ></ConfettiExplosion>
    </div>
</template>
<script>

import { InquiryFormService } from '../../../_services';
import { AlertDialog } from "@/_helpers/AlertDialog";
export default {
    mixins: [AlertDialog],
    props: {
        Type: [String, Number],
        user: Object,
        rid: Number,
        mobile: Boolean,
        simulatedSupplier: Object,
        // Which sales lead type is being unlocked. Backend expects string.
        // Examples: 'Enquiry', 'NameCard'
        unlockType: {
            type: String,
            default: 'Enquiry'
        }
    },
    inject: ["GetDetail"],
    data() {
        return {
            cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/Images/",
            IsLock: true,
            YearRemainingQuota: 0,
            EveryYearQuota: 0
        }
    },
    computed: {
        langId() {
            return localStorage.getItem("currentLangId")
        },
        langCode() {
            return localStorage.getItem("currentLang")
        },
        lockImg() {
            return `${this.cdnURL}SalesLead-lock.png?x-oss-process=image/format,webp`
        },
        unlockImg() {
            return `${this.cdnURL}SalesLead-unlock.png?x-oss-process=image/format,webp`
        },
        DialogImg() {
            return `${this.cdnURL}SalesLead-lockQuota.png?x-oss-process=image/format,webp`
        },
        UpgradeUrl() {
            return `https://www.chinaplasonline.com/eMarketplace/Supplier/${this.langCode}?scroll=supplier_MembershipsBenefits`;
        },
        LockAndNonQuota() { // 当前是锁的状态并且还有额度
            return this.IsLock && this.YearRemainingQuota > 0;
        },
        isNameCardUnlock() {
            return String(this.unlockType || '').toLowerCase() === 'namecard';
        },
        isBookmarkUnlock() {
            return String(this.unlockType || '').toLowerCase() === 'bookmark';
        },
        dialogTitleKey() {
            if (this.isNameCardUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Title_NameCard';
            if (this.isBookmarkUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Title_Bookmark';
            return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Title';
        },
        dialogTipsKey() {
            if (this.isNameCardUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Tips_NameCard';
            if (this.isBookmarkUnlock) return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Tips_Bookmark';
            return 'lbl_EMPBE_SalesLeadFreeQuota_Dialog_Tips';
        },
        bookmarkQuotaText() {
            const text = this.$t('lbl_EMPBE_SalesLead_LikeFollow_FreeCreditsLeft');
            return String(text || '')
                .replace('{currentQuota}', this.YearRemainingQuota)
                .replace('{count}', this.YearRemainingQuota);
        },
        bookmarkSendInvitationText() {
            const text = this.$t('lbl_EMPBE_SalesLead_LikeFollow_SendInvitationWithQuota');
            const quota = `${this.YearRemainingQuota}/${this.EveryYearQuota}`;
            return String(text || '')
                .replace('{quota}', quota)
                .replace('{currentQuota}', this.YearRemainingQuota)
                .replace('{maxQuota}', this.EveryYearQuota);
        },
        DialogText() {
            return `
                <div  style="color: var(--On-Surface-80, rgba(0, 0, 0, 0.80));font-feature-settings: 'liga' off, 'clig' off;font-size: 14px;font-style: normal;font-weight: 400;line-height: 150%; ">
                    You have <span style="font-weight: 700;">${this.YearRemainingQuota} free quota</span>credit remaining. Click Confirm to unlock this buyer’s contact details. Alternatively, choose to "Upgrade Plan" to enjoy unlimited credits and seize the business opportunities.
                <div>

                <div  style="color: var(--On-Surface-80, rgba(0, 0, 0, 0.80));font-feature-settings: 'liga' off, 'clig' off;font-size: 14px;font-style: normal;font-weight: 400;line-height: 150%; ">
                    You have <span style="font-weight: 700;">{remainingCredit} free quota</span>credit remaining. Click Confirm to unlock this buyer’s contact details. Alternatively, choose to "Upgrade Plan" to enjoy unlimited credits and seize the business opportunities.
                <div>
            `
        }
    },
    watch: {
        rid() {
            this.GetProductQuta();
        },
        unlockType() {
            // 当 unlockType 变化时（切换标签页），重新获取配额
            this.GetProductQuta();
        }
    },
    mounted() {
        this.GetProductQuta();
    },
    methods:
    {
        tLabel(eventName) {
            // Format: EMP3_SalesLead_类型_事件名称_id
            const type = this.unlockType || 'Enquiry';
            const id = this.rid || 0;
            return `EMP3_SalesLead_${type}_${eventName}_${id}`;
        },
        GetProductQuta() {
            var that = this;
            InquiryFormService.GetUnlockQuotaFree({ companyId: that.user.empCompanyId, type: that.unlockType })
                .then((res) => {
                    if (res) {
                        that.YearRemainingQuota = res.yearUnlockQuota.yearRemainingQuota;
                        that.EveryYearQuota = res.yearUnlockQuota.everyYearQuota;
                        that.IsLock = !res.unlockQuotaList.includes(that.rid);
                        that.$emit('unlockQuota', that.IsLock && this.YearRemainingQuota==0);
                        that.$emit('unlockQuotaInfo', {
                            isLock: that.IsLock,
                            yearRemainingQuota: that.YearRemainingQuota,
                            everyYearQuota: that.EveryYearQuota
                        });
                    }
                });
        },
        OpenDialog() {
            if(this.simulatedSupplier) return;
            var className = "AlertDialog-SalesLead-SaveSucess ";
            className += (this.LockAndNonQuota ? 'AlertDialog-popup-Salelead-Unlock' : 'AlertDialog-popup-Salelead-lock')
            this.showConfirm_Img(
                this.$t(this.dialogTitleKey),
                this.$t(this.dialogTipsKey,{remainingCredit:this.YearRemainingQuota, currentQuota: this.YearRemainingQuota}),
                this.$t('lbl_EMPBE_Confirm'),
                this.$t('lbl_EMPBE_Cancel'),
                this.$t('lbl_EMPBE_SalesLeadFreeQuota_Defaultbutton'),
                this.DialogImg,
                200,
                200,
                className,
                this.LockAndNonQuota,
                "EMPBE_Sale_Lead_UnlockConfirm",
                "EMPBE_Sale_Lead_UnlockCancel",
                "EMPBE_Sale_Lead_SalesLeadFreeQuota"
            ).then(res => {
                if (res.isDenied) {
                    window.open(this.UpgradeUrl, '_blank');
                } else if (res.isConfirmed && this.LockAndNonQuota) {
                    this.AddUnlockQuotaFree();
                    this.$refs.confetti.triggerConfetti();
                }
            });
        },
        AddUnlockQuotaFree() {
            var param = {
                EmpCompanyId: this.user.empCompanyId,
                UnlockType: this.unlockType,
                RelatedRID: this.rid,
                URL: window.location.href,
                BAgent: window.navigator.userAgent
            }
            InquiryFormService.AddUnlockQuotaFree(param).then(res => {
                if (res.isSuccessful) {
                    this.GetProductQuta();
                    //刷新最顶部层级
                    this.GetDetail();
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.unlock-quota-free-container {
    width: 100%;

}


.unlock-quota-free-Page-Unlock {
    background: linear-gradient(90deg, #F1F0FF 0%, #F2F3F5 100%);

}

.unlock-quota-free-Page-lock {
    background: linear-gradient(90deg, #CB242B 0%, #7128E8 100%), radial-gradient(708.4% 271.29% at 27.34% -79.5%, #BE2A39 0%, #350091 100%);

}

.unlock-quota-free-Page {
    display: flex;
    padding: var(--16, 16px) var(--24, 24px);
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: stretch;
    align-self: stretch;
    gap: 7px;
    border-radius: 8px;

    .unlock-quota-free-Page-Nav {
        display: flex;
        align-items: center;
        align-self: stretch;
        gap: 7px;
    }

    .unlock-quota-free-Page-Nav-Body {
        display: flex;
        gap: 8px;
        flex-direction: column;
    }

    .Title-lock {
        color: var(--BG-Surface, #FFF);
        /* Inter/Text/Headline 6 */
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        /* 20.8px */
    }

    .Title-Unlock {
        color: var(--On-Surface-80, rgba(0, 0, 0, 0.80));
        /* Inter/Text/Headline 6 */
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        /* 20.8px */
        /* 20.8px */
    }

    .UnlockButton {
        white-space: nowrap;
        display: flex;
        padding: 8px 12px !important;
        align-items: center;
        border-radius: 4px;
        background: #7968FF;
        color: #FFF;

        text-align: center;
        -webkit-text-stroke-color: #FFF;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        /* 21px */
        letter-spacing: -0.154px;
        justify-content: center;
    }

    .lockButton {
        white-space: nowrap;
        display: flex;
        padding: var(--8, 8px);
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 4px;
        border: 1px solid var(--On-Soild-w80, rgba(255, 255, 255, 0.80));
        cursor: pointer;
        color: var(--On-Surface-White, #FFF) !important;
        color: var(--On-Surface-White, #FFF);
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
        /* 21px */
        letter-spacing: -0.154px;
        /* 12px */
        // &:hover {
        //     background-color: #0056b3;
        // }
    }
}

.unlock-quota-free {
    display: flex;
    padding: var(--8, 8px) var(--16, 16px);
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    border-radius: var(--8, 8px);
    background: linear-gradient(90deg, #CB242B 0%, #7128E8 100%), radial-gradient(708.4% 271.29% at 27.34% -79.5%, #BE2A39 0%, #350091 100%), radial-gradient(613.45% 250.6% at 37.78% -60.98%, #FF3A3A 0%, #5E0101 100%), radial-gradient(613.45% 250.6% at 37.78% -60.98%, #573AFF 0%, #09015E 100%);

    .unlock-quota-free-Title {

        color: var(--On-Surface-White, #FFF);
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        /* 20.8px */
    }

    a {
        text-decoration: none;
        white-space: nowrap;
        display: flex;
        padding: var(--8, 8px);
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 4px;
        border: 1px solid var(--On-Soild-w80, rgba(255, 255, 255, 0.80));
        cursor: pointer;
        color: var(--On-Surface-White, #FFF) !important;
        // NOTE: `leading-trim` / `text-edge` are not widely supported and trigger lint warnings.
        font-feature-settings: 'liga' off, 'clig' off;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 100%;
        /* 12px */
        // &:hover {
        //     background-color: #0056b3;
        // }
    }
}
</style>